import React from 'react';

import type { TooltipProps } from 'recharts';
import type { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
import { Mask } from 'v2/components/Shared/ValuesVisibility';

type CustomTooltipProps = TooltipProps<ValueType, NameType>;

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        border: '1px solid #ccc',
        padding: '8px 12px',
        fontSize: 14
      }}
    >
      <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>

      {payload.map((entry, index) => (
        <p
          key={index}
          style={{
            margin: 0,
            color: entry.color
          }}
        >
          {`${entry.name}: `}
          <Mask>{entry.value}</Mask>
        </p>
      ))}
    </div>
  );
};

export default CustomTooltip;
